module.exports = "<div class=\"widget wide-{{widget.size[0]}} tall-{{widget.size[1]}}\" [ngClass]=\"{'no-padding': noPadding, last: last}\">\n  <div class=\"header\" *ngIf=\"header\">\n    <ng-content select=\"[widget-header]\"></ng-content>\n  </div>\n  <div class=\"content\">\n    <ng-content select=\"[widget-content]\"></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/widget.component.html
// module id = ./src/app/widgets/widget.component.html
// module chunks = main